import React, { useEffect } from 'react';
import Hero from '../common/Hero';
import Footer from '../common/Footer';
import { initAnimations } from '../../utils/animations';
import About1 from '../../assets/images/harvey5.jpg';
import About2 from '../../assets/images/harvey1.jpeg';
import About3 from '../../assets/images/harvey2.jpeg';
import Child from "../../assets/images/about-child.jpg";
import AppScreenshot1 from "../../assets/images/1.png";
import AppScreenshot2 from "../../assets/images/2.png";
import AppScreenshot3 from "../../assets/images/3.png";
import AppScreenshot4 from "../../assets/images/4.png";

const About = () => {
  useEffect(() => {
    initAnimations();
  }, []);

  const breadcrumbs = [
    { text: 'Home', link: '/' },
    { text: 'About' }
  ];

  return (
    <>
      <Hero
        title="About Harvey Masjid"
        breadcrumbs={breadcrumbs}
      />

      <div className="container-fluid about py-5">
        <div className="container py-5">
          <div className="row g-5 mb-5">
            <div className="col-xl-6">
              <div className="row g-4">
                <div className="col-6">
                  <img
                    src={About1}
                    className="img-fluid  wow zoomIn"
                    data-wow-delay="0.1s"
                    alt="Harvey Masjid Exterior"
                  />
                </div>
                <div className="col-6">
                  <img
                    src={About2}
                    className="img-fluid pb-3 wow zoomIn"
                    data-wow-delay="0.1s"
                    alt="Prayer Hall"
                  />
                  <img
                    src={About3}
                    className="img-fluid pt-3 wow zoomIn"
                    data-wow-delay="0.1s"
                    alt="Islamic Classes"
                  />
                </div>
              </div>
            </div>
            <div className="col-xl-6 wow fadeIn" data-wow-delay="0.5s">
              <p className="fs-5 text-uppercase text-primary">About Our Masjid</p>
              <h1 className="display-5 pb-4 m-0">Serving the Muslim Community </h1>
              <p className="pb-4">
                Harvey Masjid has been a cornerstone of the Muslim community in Harvey,
                providing spiritual guidance, education, and social services for nearly three decades.
                Our mission is to foster an environment of worship, learning, and community building
                in accordance with Islamic principles.
              </p>
              <div className="row g-4 mb-4">
                <div className="col-md-6">
                  <div className="vision-mission-box">
                    <div className="icon-container">
                      <div className="icon-bg">
                        <i className="fa fa-eye"></i>
                      </div>
                    </div>
                    <div className="content">
                      <h5>Our Vision</h5>
                      <p>To be a beacon of Islamic knowledge and values that serves all community members</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="vision-mission-box">
                    <div className="icon-container">
                      <div className="icon-bg">
                        <i className="fa fa-flag"></i>
                      </div>
                    </div>
                    <div className="content">
                      <h5>Our Mission</h5>
                      <p>To provide religious, educational, and social services to Muslims and the wider community</p>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="bg-light p-3 mb-4">
                <div className="row align-items-center justify-content-center">
                  <div className="col-3">
                    <img src={Child} className="img-fluid rounded-circle" alt="Children Learning" />
                  </div>
                  <div className="col-6">
                    <p className="mb-0">
                      Our weekend Islamic school has educated over 500 children in Quran, Arabic,
                      and Islamic studies since its establishment.
                    </p>
                  </div>
                  <div className="col-3">
                    <h2 className="mb-0 text-primary text-center">$42,850</h2>
                    <h5 className="mb-0 text-center">Raised</h5>
                  </div>
                </div>
              </div> */}
              <div className="row g-2">
                <div className="col-md-6">
                  <p className="mb-2"><i className="fa fa-check text-primary me-3"></i>Daily Prayers & Jumu'ah</p>
                  <p className="mb-0"><i className="fa fa-check text-primary me-3"></i>Quran & Arabic Classes</p>
                </div>
                <div className="col-md-6">
                  <p className="mb-2"><i className="fa fa-check text-primary me-3"></i>Youth Programs</p>
                  <p className="mb-0"><i className="fa fa-check text-primary me-3"></i>Community Services</p>
                </div>
              </div>
            </div>
          </div>



          {/* Mobile App Section */}
          <div className="container text-center bg-light py-5 my-5 wow fadeIn" data-wow-delay="0.1s">
            <div className="row g-4 align-items-center">
              {/* Left Icon */}
              <div className="col-lg-2">
                <i className="fas fa-mobile-alt fa-5x text-primary"></i>
              </div>

              {/* Text & Buttons */}
              <div className="col-lg-5 text-center text-lg-start">
                <h2 className="mb-3">Download Our Mobile App</h2>
                <p className="mb-4">
                  Stay connected with Harvey Masjid through our official mobile application.
                  Get prayer times, event notifications, and more.
                </p>
                <div className="d-flex flex-wrap justify-content-center justify-content-lg-start">
                  <a href="/app-store" className="btn btn-dark m-2">
                    <i className="fab fa-apple me-2"></i> App Store
                  </a>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.wasuan8.Harveymasjid"
                    className="btn btn-dark m-2"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-google-play me-2"></i> Google Play
                  </a>
                </div>
              </div>

              {/* Screenshot Grid */}
              <div className="col-lg-5">
                <div className="row g-3">
                  <div className="col-6">
                    <img src={AppScreenshot1} className="img-fluid rounded shadow" alt="Prayer Times" />
                  </div>
                  <div className="col-6">
                    <img src={AppScreenshot2} className="img-fluid rounded shadow" alt="Events" />
                  </div>
                  <div className="col-6">
                    <img src={AppScreenshot3} className="img-fluid rounded shadow" alt="Donations" />
                  </div>
                  <div className="col-6">
                    <img src={AppScreenshot4} className="img-fluid rounded shadow" alt="Quran" />
                  </div>
                </div>
              </div>
            </div>
          </div>



          <div className="container text-center bg-primary py-5 wow fadeIn" data-wow-delay="0.1s">
            <div className="row g-4 align-items-center">
              <div className="col-lg-2">
                <i className="fa fa-mosque fa-5x text-white"></i>
              </div>
              <div className="col-lg-7 text-center text-lg-start">
                <h1 className="mb-0">Join Us in Strengthening Our Community Through Faith and Service</h1>
              </div>
              <div className="col-lg-3">
                <a href="https://play.google.com/store/apps/details?id=com.wasuan8.Harveymasjid" className="btn btn-light py-2 px-4">Volunteer</a>
              </div>
            </div>
          </div>
        </div>
      </div>



      <Footer />
    </>
  );
};

export default About;